export class TorchKpiBvrMonthly {
  id: number;
  bvrDate: Date;
  actual: number;
  actualYearToDate: number;
  forecast: number;
  planned: number;
}
